import axios from 'axios'
// axios.defaults.baseURL = '/api'
import browser from './browser'
import qs from 'qs'
import * as Prompt from '../components/Message';
import moment from 'moment'
// 超大数据要用这个处理过才行
import JSONbig from 'json-bigint'
// import appHelper from '@/utils/AppHelper'

// 创建 axios 实例
const http = axios.create({
  // headers: {'Content-Type': 'application/json'},
  timeout: 30000,
  transformResponse: [
    function(data) {
      try {
        var a = '';
        if (data) {
          a = JSON.parse(data);
        }
        return a;
      } catch (error) {
        console.error(error, 99999, data)
      }
      return JSONbig.parse(data)
    }
  ]
})

// 设置 post、put 默认 Content-Type
http.defaults.headers.post['Content-Type'] = 'application/json'
http.defaults.headers.put['Content-Type'] = 'application/json'

// 添加请求拦截器
http.interceptors.request.use(config => {
  // console.log(config)
  if (config.method === 'post' || config.method === 'put') {
    // post、put 提交时，将对象转换为string, 为处理Java后台解析问题
    if (!(config.data instanceof FormData)) {
      config.data = qs.stringify(config.data)
    }
  } else if (config.method === 'get' && browser.isIE) {
    // 给GET 请求后追加时间戳， 解决IE GET 请求缓存问题
    const symbol = config.url.indexOf('?') >= 0 ? '&' : '?'
    config.url += symbol + '_=' + Date.now()
  }
  // 请求发送前进行处理
  return config
}, error => {
  // 请求错误处理
  return Promise.reject(error)
})

// 添加响应拦截器
http.interceptors.response.use(response => {
  var { data } = response

  // console.log('response', response);
  if (response.status != 200 || !data.success) {
    // console.log('response.data', data)
    // 请求返回失败信息写到local
    var rconfig = response.config
    setTimeout(function() {
      var reqerr = {
        url: rconfig.url,
        ret: JSON.stringify(data),
        status: response.status,
        time: moment().format('YYYY-MM-DD HH:mm:ss')
      }
      // console.log('reqe', reqerr);
      var strErr = window.localStorage.getItem('req_err');
      var reqErr = {
        count: 0,
        list: []
      };
      if (strErr) {
        reqErr = JSON.parse(strErr);
      }
      reqErr.list.push(reqerr);
      reqErr.count = reqErr.list.length
      window.localStorage.setItem('req_err', JSON.stringify(reqErr));
    }, 1000)
  }
  return data
}, error => {
  let info = {}
  console.log(JSON.stringify(error))
  // console.log(error.config.url)

  var err_url = ''
  if (error.config && error.config.url) {
    err_url = error.config.url
  }
  if (!error.response) {
    info = {
      url: err_url,
      code: 5000,
      msg: 'Network Error'
    }
    // Prompt.Message.show('连接网络失败, 正在重新连接...', '#F56C6C', 2)
    // Prompt.ErrMessage.show('', '#546E7A', 2)
  } else {
    // 此处整理错误信息格式
    const { status, statusText, data } = error.response
    info = {
      url: err_url,
      code: status,
      data: data,
      msg: statusText
    }
    if (info.code === 401) {
      // Prompt.ErrMessage.show('Not Authorized.', '#F56C6C', 2)
      Prompt.ErrMessage.show('', '#546E7A', 2)
    } else {
      // console.log('info', info);
      // Prompt.Message.show(info.code + ', ' + info.msg, '#F56C6C', 2)
      Prompt.ErrMessage.show('', '#546E7A', 2)
    }
  }
  return Promise.reject(info)
})

/**
 * 创建统一封装过的 axios 实例
 * @return {AxiosInstance}
 */
export default function() {
  return http
}
